module.exports = __webpack_public_path__ + "img/热销榜单.8d673547.png";